import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-nms-success-rate',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressBarModule],
  templateUrl: './nms-success-rate.html',
  styleUrl: './nms-success-rate.scss',
})
export class NmsSuccessRateComponent {
  readonly successfulCount = input.required<number>();
  readonly totalCount = input.required<number>();

  readonly percentage = computed(() => {
    const total = this.totalCount();
    if (total <= 0) {
      return 0;
    }

    return Math.round((this.successfulCount() / total) * 100);
  });
}
